export const applicationPutMock = {
  "id": "74cf4737-084b-4638-9771-c881f62f59f1",
  "user": {
    "id": "QTAz9XKvt1IWTmJ3LhbHlrDSZA",
    "userId": "74cf4737-084b-4638-9771-c881f62f59f1",
    "primaryPhone": "+381665126482",
    "href": "https://engdobs-idx-latest.identityx-cloud.com/onboardingdemo/IdentityXServices/rest/v1/users/QTAz9XKvt1IWTmJ3LhbHlrDSZA",
    "relHref": "/onboardingdemo/IdentityXServices/rest/v1/users/QTAz9XKvt1IWTmJ3LhbHlrDSZA",
    "idCheck": {
      "id": "LjbpBiib1D1j1L6n0FJiqA",
      "referenceId": "f372c1c3-a3e9-4a89-8744-10f54993a8cc",
      "href": "https://engdobs-idx-latest.identityx-cloud.com/onboardingdemo/DigitalOnBoardingServices/rest/v1/users/QTAz9XKvt1IWTmJ3LhbHlrDSZA/idchecks/LjbpBiib1D1j1L6n0FJiqA",
      "relHref": "/onboardingdemo/DigitalOnBoardingServices/rest/v1/users/QTAz9XKvt1IWTmJ3LhbHlrDSZA/idchecks/LjbpBiib1D1j1L6n0FJiqA"
    }
  }
}